import { useEffect, useState, useContext, useCallback } from "react";
import ThemeContext from '../../src/utils/contexts/themeContext';
import { useTranslation } from "react-i18next";
export default function PopupWithHeading(
    {
        terms = false,
        show = false,
        title = '',
        backButton = false,
        onStatusChange,bgThemeUp=true,
        className="",
        ...props
    }) {
    const { t: trans, i18n } = useTranslation([]);
    let lang = i18n.language;
    const themeMode = useContext(ThemeContext);
    return (
        show ? <div className='popup' >

            { 
                terms != true 
                    ? <section className={`popup-container theme-${themeMode} nice-apply-theme ${bgThemeUp? " bg-theme-up ":""} `+className}>
                        <div className="popup-container-header">
                            <div className="popup-close nice-select-none" onClick={() => {
                                if (onStatusChange) {
                                    onStatusChange(false);
                                }
                            }}>{backButton ?
                                <div className="back-btn nice-pointer absolute ">
                                    <img src='/assets/icons/back.svg' className={lang == "en" ? "rotate-180" : ""}  alt="back" />
                                </div>
                                : "x"}</div>
                            <h3 className="text-40 font-bold text-center mt-20">{title}</h3>
                            {
                                props.children
                            }
                        </div>
                    </section> 
                    
                    : <section className={`popup-container theme-${themeMode} nice-apply-theme ${bgThemeUp? " bg-theme-up ":""} `+className}>
                        <div className="popup-container-header">
                            <div className=" top-position bg-gray">
                                <div className="popup-close nice-select-none text-nun" onClick={() => {
                                    if (onStatusChange) {
                                        onStatusChange(false);
                                    }
                                }}>
                                    {
                                    backButton
                                        ? <div className="back-btn nice-pointer absolute ">
                                            <img src='/assets/icons/back.svg' className={lang == "en" ? "rotate-180" : ""}  alt="back" />
                                        </div>
                                        : <span className="text-60">x</span>
                                    }
                                </div>
                                <h3 className="text-40 font-bold text-center mt-20 top-text-padding">{title}</h3>
                            </div>
                            { props.children }
                        </div>
                    </section>
                
            }
            
            
           

        </div> : null
    );
}